// src/components/Loader.jsx
import React from 'react';

const Loader = () => (
  <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-[#2E453D] border-solid"></div>
  </div>
);

export default Loader;
